/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：361
 */

"use strict"

export { o$Provider as a }
import { createContext } from /* 0 */"react"
var o = createContext(null)
var /* [auto-meaningful-name] */o$Provider = o.Provider
export { o as b }
export default o$Provider
